var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 19,
    height: 17.75,
    fill: "url(#pattern0_115_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_115_26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_115_26",
    transform: "matrix(0.00666667 0 0 0.00713615 0 -0.0352113)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_115_26",
    width: 150,
    height: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAABKhJREFUeF7t3TFuE1EQgOG3N0hukRJ6JDgCVDlHapQqUPscqeAIINFDmVuQGywShSVbWc+MXt6TE33U89bk599/guS1l8vdl7U9y5/159+b2w/VS13svr5Z2vq7em70/NrWT483t99Pvc7F7u7j0pZvo/8u1euvbXn7ePP5T/Xc5e7uR2vL++q5p+YXYj2NkVh9ehFrgx+xiNVHgFh7AlbhEJUOL6pYfZCtQsVSrL57qHZasWq8jqcVS7EUq+8eqp1WrBovxUryIlYS1MaYVWgVWoV991DttGLVeFmFSV7ESoKyCmugiFXjpVh9vF7Eae9uaK2d69tmXoRBm//x8LYZYg0wWLEUa4BWrRGLWMSKCbyutybHP+/5TiiWYg2xk1jEIlZMwCqMGc2ZUCzFGmIasYhFrJiAVRgzmjOhWIo1xDRiEYtYMQGrMGY0Z0KxFGuIacQiFrFiAlZhzGjOhGIp1hDTiEUsYsUErMKY0ZwJxVKsIaYRi1jEiglYhTGjOROKdd7Ful/a+nBKhbUtV6216zm65F+FWGcslieh8yI/NenTZjb4EYtYfQSItSfgU5OHqHR4UcXqg2wVKpZi9d1DtdOKVeN1PK1YiqVYffdQ7bRi1XgpVpIXsZKgNsasQqvQKuy7h2qnFavGyypM8iJWEpRVWANFrBovxUryIlYSlGLVQBGrxkuxkryIlQSlWDVQxKrxUqwkL2IlQSlWDRSxarwUK8mLWElQilUDRawaL8VK8iJWEpRi1UARq8ZLsZK81qXdtnX9dXJ8Wd4ta7tLXnLamOcKz/i5wmkWDHghYhFrgFa+Vu4/VN+w+vxuKRaxnt+qpliKNUQrYhGLWBkCPh8rQ2nGjN+x/I41xDNiEYtYMQGrMGY0Z0KxFGuIacQiFrFiAlZhzGjOhGIp1hDTiEUsYsUErMKY0ZwJxVKsIaYRi1jEiglYhTGjOROKpVhDTCMWsYgVE7AKY0ZzJhRLsYaYRixiESsm8LpWoQdW43/xUxM+532DjkfsidVHgFh7Ar6vcIhKhxdVrD7IVqFiKVbfPVQ7rVg1XsfTiqVYitV3D9VOK1aNl2IleRErCWpjzCq0Cq3CvnuodlqxaryswiQvYiVBWYU1UMSq8VKsJC9iJUEpVg0UsWq8FCvJi1hJUIpVA0WsGi/FSvIiVhKUYtVAEavGS7GSvIiVBKVYNVDEqvFSrCQvYiVBKVYNFLFqvBQryYtYSVCKVQZ1v7T14dSptS1XrbXr8pUHH/AktCehhyhGLGIRKybwuh6xj3/e851QLMUaYiexiEWsmIBVGDOaM6FYijXENGIRi1gxAaswZjRnQrEUa4hpxCIWsWICVmHMaM6EYinWENOIRSxixQSswpjRnAnFUqwhphGLWMSKCViFMaM5E4qlWENMIxaxiBUTsApjRnMmFEuxhphGLGIRKyZgFcaM5kwo1hkXy5PQfTeBLxDY4EcsYvURINaegC/CHKLS4UUVqw+yVahYitV3D9VOK1aN1/G0YimWYvXdQ7XTilXjpVhJXsRKgtoYswqtQquw7x6qnVasGi+rMMmLWElQVmENFLFqvBQryYtYSVAbY/8AAOL5r9isDdwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.cc2f312c774e728a8df7d3c4b48a0cec.svg";
export { ForwardRef as ReactComponent };